import '../../../sass/components/formBuilder.scss';

import { form as Formify } from 'formifier';
import { ERROR_MESSAGES } from './errorMessages';
import { initializeCheckboxGroupValidation } from './checkboxGroupValidation';
import { scrollToFirstInvalidField } from './formManagement';
import { initializeReferralCodeHelper } from './referralCodeHelper';
import { initializeCampaignIdHelper } from './campaignIdHelper';
import { initializeClickIdHelper } from './clickIdHelper';
import { initializeRecaptchas } from './recaptcha';
import { initializeGaHelper } from './gaHelper';
import { handleSubmit } from './ajax';

const init = () => {
  initializeCheckboxGroupValidation();
  initializeReferralCodeHelper();
  initializeCampaignIdHelper();
  initializeClickIdHelper();
  initializeGaHelper();

  const builderForms = document.querySelectorAll('.FormBuilder form');
  builderForms.forEach((formElem) => {
    if (formElem.dataset.ajaxForm) {
      Formify(ERROR_MESSAGES, formElem, handleSubmit);
    } else {
      Formify(ERROR_MESSAGES, formElem);
    }

    formElem.addEventListener('formifierInvalid', (event) => {
      scrollToFirstInvalidField(event.target);
    });
  });
};

window.addEventListener('DOMContentLoaded', init);
document.addEventListener('recaptchaLoaded', initializeRecaptchas, {
  once: true
});
